import { render, staticRenderFns } from "./PosTableDetail.vue?vue&type=template&id=743fc17c"
import script from "./PosTableDetail.vue?vue&type=script&lang=js"
export * from "./PosTableDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports